module.exports = __webpack_public_path__ + "static/img/product_society_society_zhsp.6618f24.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_society_society_zhsp.svg
// module id = Yd9K
// module chunks = 0